import React from 'react'
import {Formik, Form, Field} from 'formik';
import * as Yup from 'yup';

import {getBookingEngineTranslations} from "@assets/js/functions/helpers";
import CountrySelector from "../CountrySelector";

const translations = getBookingEngineTranslations();

const InputTooltip = ({
    field,
    form: {values, touched, errors},
    ...props
}) => {
    const isNotValid = touched[field.name] && errors[field.name]
    const show = isNotValid || values[field.name]

    return <div data-tooltip={translations['form_field-invalid']}>
        <label className={`form-label ${show && 'form-label--show'} ${isNotValid && 'form-label--invalid'}`}>
            {props.placeholder}
        </label>
        <input
            className={`form-field ${isNotValid && 'form-field--invalid'}`}
            maxLength={50}
            type="text" {...field} {...props}
        />
        {isNotValid && <span className='form-field--invalid-label'>{translations['form_field-invalid']}</span>}
    </div>
}

const RegisterSchema = Yup.object().shape({
    firstName: Yup.string()
        .required('To pole jest wymagane'),
    lastName: Yup.string()
        .required('To pole jest wymagane'),
    tel: Yup.string()
        .required('To pole jest wymagane'),
});

const copyAddress = (setFieldValue, values) => {
    const addressFields = ['street', 'streetNumber', 'city', 'postalCode', 'country'];

    addressFields.forEach(field => {
        setFieldValue(`invoice_${field}`, values[field]);
    });

    if (values.invoice_type === 'individual') {
        setFieldValue('invoice_company', `${values.firstName.trim()} ${values.lastName.trim()}`);
    }
};

export default React.forwardRef((props, ref) => {
    return <Formik
        initialValues={props.initialValues}
        validationSchema={RegisterSchema}
        onSubmit={values => {
            props.onSubmit(values)
        }}
        ref={ref}
    >
        {({values, setFieldValue}) => {
            const isDiffDigit = (e, diffFrom) => {
                const actual = diffFrom
                const coming = e.target.value
                const diff = coming.split('').filter(function (val, i) {
                    return val !== actual.charAt(i)
                })[0];

                return diff ? !isNaN(parseInt(diff)) : true
            }

            return <Form>
                <div
                    className="user_box user_box--register"
                >
                    <div className="user_box__column user_box__column--left">
                        <Field
                            name="firstName"
                            placeholder={translations['placeholder-firstname'] + '*'}
                            component={InputTooltip}
                        />
                        <Field
                            name="lastName"
                            placeholder={translations['placeholder-lastname'] + '*'}
                            component={InputTooltip}
                        />
                        <Field
                            name="tel"
                            placeholder={translations['placeholder-phone'] + '*'}
                            component={InputTooltip}
                            onChange={e => {
                                if (isDiffDigit(e, values.tel)) setFieldValue('tel', e.target.value)
                            }}
                        />
                    </div>
                    <div className="user_box__column user_box__column--right">
                        <Field
                            name='country'
                            component={CountrySelector}
                            initialValue={props.initialValues.country}
                            onChange={countryCode => {
                                setFieldValue('country', countryCode)
                            }}
                        />
                        <Field
                            name="street"
                            placeholder={translations['placeholder-street']}
                            className='form-field'
                            component={InputTooltip}
                        />
                        <div className="user_box__column--divide">
                            <Field
                                name="streetNumber"
                                placeholder={translations['placeholder-street-nr']}
                                className='form-field'
                                component={InputTooltip}
                            />
                            <Field
                                name="roomNumber"
                                placeholder={translations['placeholder-room-nr']}
                                className='form-field'
                                component={InputTooltip}
                            />
                        </div>
                        <div className="user_box__column--divide">
                            <Field
                                name="city"
                                placeholder={translations['placeholder-city']}
                                className='form-field'
                                component={InputTooltip}
                            />
                            <Field
                                name="postalCode"
                                placeholder={translations['placeholder-postalcode']}
                                className='form-field'
                                component={InputTooltip}
                            />
                        </div>
                        <Field
                            name="comments"
                            placeholder={translations['placeholder-comments']}
                            className='form-field form-field--textarea'
                            component='textarea'
                        />
                    </div>
                </div>

                <div className="before-like-header"></div>
                <h3 className="like-header">{translations['invoice']}</h3>
                <br/>

                {props.invoiceNeeded &&
                    <div>
                        <button
                            type="button"
                            className="link-button copy-btn"
                            onClick={() => copyAddress(setFieldValue, values)}
                        >
                            {translations["placeholder-copy-address"]}
                        </button>
                        <div className="user_box user_box--register">
                        <div className="user_box__column user_box__column--left">
                                <div className="invoice-types" role="group">
                                    <label>
                                        <Field
                                            type="radio"
                                            name="invoice_type"
                                            value="individual"
                                            checked={values.invoice_type === 'individual'}
                                        />
                                        {translations['invoice-type-individual']}
                                    </label>
                                    <label>
                                        <Field
                                            type="radio"
                                            name="invoice_type"
                                            value="company"
                                            checked={values.invoice_type === 'company'}
                                        />
                                        {translations['invoice-type-company']}
                                    </label>
                                </div>
                                <Field
                                    name="invoice_company"
                                    placeholder={values.invoice_type === "individual" ? translations['placeholder-first-and-last-name'] : translations['placeholder-company']}
                                    component={InputTooltip}
                                />
                                {values.invoice_type === 'company' && (
                                    <>
                                        <Field
                                            name="invoice_nip"
                                            placeholder={translations['placeholder-nip']}
                                            component={InputTooltip}
                                        />
                                    </>
                                )}
                                <Field
                                    name='invoice_country'
                                    component={CountrySelector}
                                    initialValue={props.initialValues.country}
                                    onChange={countryCode => {
                                        setFieldValue('invoice_country', countryCode)
                                    }}
                                />
                            </div>
                            <div className="user_box__column user_box__column--right">
                            <Field
                                    name="invoice_street"
                                    placeholder={translations['placeholder-street']}
                                    component={InputTooltip}
                                />
                                <div className="user_box__column--divide">
                                <Field
                                        name="invoice_streetNumber"
                                        placeholder={translations['placeholder-street-nr']}
                                        component={InputTooltip}
                                    />
                                    <Field
                                        name="invoice_roomNumber"
                                        placeholder={translations['placeholder-room-nr']}
                                        component={InputTooltip}
                                    />
                                </div>
                                <div className="user_box__column--divide">
                                    <Field
                                        name="invoice_city"
                                        placeholder={translations['placeholder-city']}
                                        component={InputTooltip}
                                    />
                                    <Field
                                        name="invoice_postalCode"
                                        placeholder={translations['placeholder-postalcode']}
                                        component={InputTooltip}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                }

                <small>
                    {translations['registered-user-form-1']}<br/>
                    {translations['registered-user-form-2']}
                    <a className='color-vc' href={`${location.origin}/profil/details`} target="_blank">
                        {translations['registered-user-form-3']}
                    </a>.
                </small>
            </Form>
        }}
    </Formik>
    }
)
